export const PRICE_VAT_PREFERENCE_STORAGE_KEY = 'kav_show_prices_incl_vat'

export const getPriceVatPreference = (fallback = true) => {
    if (typeof window === 'undefined' || !window.localStorage) return fallback

    try {
        const storedValue = window.localStorage.getItem(PRICE_VAT_PREFERENCE_STORAGE_KEY)
        if (storedValue === 'true') return true
        if (storedValue === 'false') return false
    } catch (error) {
        return fallback
    }

    return fallback
}

export const setPriceVatPreference = (showPricesInclVat) => {
    if (typeof window === 'undefined' || !window.localStorage) return

    try {
        window.localStorage.setItem(
            PRICE_VAT_PREFERENCE_STORAGE_KEY,
            showPricesInclVat ? 'true' : 'false'
        )
    } catch (error) {
        // Ignore storage errors; the UI state still updates for the current page.
    }
}
